import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "closeable", "onClose", "titleText", "type", "use"];
import { ALERT_TYPES, ALERT_TYPE_INFO, ALERT_USES, ALERT_USE_DEFAULT } from '../alert/AlertTypes';
import H5 from '../elements/headings/H5';
import PropTypes from 'prop-types';
import UICloseButton from '../button/UICloseButton';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function UIAlert(props) {
  const {
      children,
      className,
      closeable = UIAlert.defaultProps.closeable,
      onClose,
      titleText,
      type = ALERT_TYPE_INFO,
      use = ALERT_USE_DEFAULT
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const computedClassName = classNames("alert private-alert", ALERT_TYPES[type], className, closeable && 'private-alert--dismissable alert-dismissable', use === 'inline' && 'private-alert--inline');
  return /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
    "aria-atomic": true,
    "aria-live": "polite",
    className: computedClassName,
    role: "alert",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "private-alert__inner",
      children: [titleText && /*#__PURE__*/_jsx(H5, {
        className: "private-alert__title",
        children: titleText
      }), /*#__PURE__*/_jsx("div", {
        className: "private-alert__body has--vertical-spacing",
        children: children
      })]
    }), closeable && /*#__PURE__*/_jsx(UICloseButton, {
      "aria-hidden": true,
      className: "close private-alert__close",
      onClick: onClose,
      size: "md"
    })]
  }));
}
UIAlert.displayName = 'UIAlert';
UIAlert.propTypes = {
  /**
   * Sets the content of the alert
   */
  children: PropTypes.node,
  /**
   * Sets whether the alert is closeable or not
   */
  closeable: PropTypes.bool.isRequired,
  /**
   * Sets the callback that is called when the alert is closed
   */
  onClose: PropTypes.func,
  /**
   * Sets the title of the alert
   */
  titleText: PropTypes.node,
  /**
   * Sets the type of alert that will be displayed
   */
  type: PropTypes.oneOf(Object.keys(ALERT_TYPES)).isRequired,
  /**
   * Sets the use type within the alert type. Besides the default use, inline is
   * the only other supported use. Inline alerts should only be used within the
   * context of another component (e.g. a modal panel)
   */
  use: PropTypes.oneOf(Object.keys(ALERT_USES)).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIAlert.defaultProps = {
  closeable: false,
  type: ALERT_TYPE_INFO,
  use: ALERT_USE_DEFAULT
};